export default {
  name: 'Nazwa wyświetlana',
  description: 'Opis',
  color: 'Kolor',
  unit: 'Jednostka',
  meaning: 'Oznaczający',
  meaningNumber: 'Oznaczanie numeru instancji',
  numberOfSignificantDigits: 'Cyfry znaczące',
  hidden: 'ukryty',
  visible: 'widoczny',
  placeholder: {
    meaningId: 'Wybierz znaczenie',
    meaningInstanceNumber: 'Numer instancji',
  },
};
